"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Components_1 = require("../../Components");
var Components_2 = require("./Components");
var EventHandlerService_1 = require("../../../../Services/EventHandlerService");
var Types_1 = require("../../../../Types");
var History_1 = require("../../../../Utils/History");
var Types_2 = require("../../Types");
var Services_1 = require("../../../../Services");
var PackIdentifier_1 = require("../../../../Types/PackIdentifier");
var Pages_1 = require("./Pages");
var react_router_dom_1 = require("react-router-dom");
var SafeRedirect_1 = require("../../../../Components/SafeRedirect");
var reactstrap_1 = require("reactstrap");
var Multiple = /** @class */ (function (_super) {
    __extends(Multiple, _super);
    function Multiple(props) {
        var _this = _super.call(this, props) || this;
        _this.selectActionHandler = function (action) {
            _this.setState({
                multiplePageStatus: 1 /* Scanning */,
                selectedAction: action
            });
        };
        _this.submitBulkRequest = function (showCheckPrompt) {
            if (showCheckPrompt && (_this.state.selectedAction.value == Types_2.PackAction.MarkAsStolen.value || _this.state.selectedAction.value == Types_2.PackAction.MarkAsDestroyed.value)) {
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.ActionCannotBeUndone(_this.props.applicationData.resources, function () { return _this.submitBulkRequest(false); }));
                return;
            }
            Services_1.MultiplePackRequestService.SubmitPackRequest(_this.state.scannedPacks.map(function (packIdentifier) {
                return {
                    ProductCodeScheme: PackIdentifier_1.scheme[packIdentifier.scheme],
                    ProductCode: packIdentifier.productCode,
                    SerialNumber: packIdentifier.serialNumber,
                    BatchId: packIdentifier.batchIdentifier,
                    ExpiryDate: packIdentifier.expiry
                };
            }), _this.state.selectedAction, _this.props.applicationData.selectedLocation)
                .then(function (result) {
                if (result == "Done") {
                    _this.setState({
                        multiplePageStatus: 2 /* Done */,
                        scannedPacks: []
                    });
                }
                else {
                    EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteErrorEvent(_this.props.applicationData.resources.Error_RequestCouldNotBeSubmitted));
                }
            }).catch(function (err) {
                console.error(err);
            });
        };
        _this.addPack = function (pack) {
            var scannedPacks = _this.state.scannedPacks;
            if (_this.props.applicationData.apiProvider == "Ssr" || scannedPacks.length == 0 || (scannedPacks[0].productCode == pack.productCode && scannedPacks[0].batchIdentifier == pack.batchIdentifier)) {
                scannedPacks.push(pack);
                _this.setState({
                    scannedPacks: scannedPacks,
                    alert: ""
                });
            }
            else {
                _this.setState({ alert: _this.props.applicationData.resources.Error_PacksMustBeSameProductAndBatch });
            }
        };
        _this.setAlert = function (key) {
            _this.setState({ alert: _this.props.applicationData.resources[key] });
        };
        _this.removePack = function (pack) {
            var scannedPacks = _this.state.scannedPacks.filter(function (oldPack) { return oldPack.key() != pack.key(); });
            _this.setState({
                scannedPacks: scannedPacks
            });
        };
        if (_this.props.applicationData.calibrationData == null) {
            EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.NeedToCalibrateScannerWarningEvent(_this.props.applicationData.resources));
            History_1.default.push('/Dashboard/Safe');
        }
        _this.state = {
            multiplePageStatus: 0 /* SelectAction */,
            selectedAction: Types_2.PackAction.None,
            scannedPacks: [],
            alert: ""
        };
        _this.actions = null;
        return _this;
    }
    Multiple.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if ((prevProps.applicationData.selectedLocation != this.props.applicationData.selectedLocation && this.props.applicationData.calibrationData == null) || this.props.applicationData.locations.find(function (x) { return x.Name == _this.props.applicationData.selectedLocation; }).Type == "Pharmacist") {
            History_1.default.push('/Dashboard/Safe');
        }
    };
    Multiple.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Multiple', render: function () { return React.createElement(Components_1.DashboardPage, { content: _this.state.multiplePageStatus === 1 /* Scanning */ ?
                        React.createElement("div", null,
                            _this.state.alert && React.createElement(reactstrap_1.Alert, { color: "danger" }, _this.state.alert),
                            React.createElement(Components_2.ScanArea, { addPack: _this.addPack, removePack: _this.removePack, scannedPacks: _this.state.scannedPacks, connectionState: _this.props.applicationData.connectionState, calibrationData: _this.props.applicationData.calibrationData, setAlert: _this.setAlert, resources: _this.props.applicationData.resources }))
                        :
                            React.createElement(Components_2.SelectAction, { availableActions: _this.props.applicationData.availableActions, onChangeHandler: _this.selectActionHandler, didSubmit: _this.state.multiplePageStatus === 2 /* Done */, resources: _this.props.applicationData.resources }), actions: _this.state.multiplePageStatus !== 1 /* Scanning */ ? null :
                        React.createElement(Components_1.ActionButton, { key: _this.state.selectedAction.value, action: _this.state.selectedAction, onClick: function () {
                                if (_this.state.scannedPacks.length > 0) {
                                    _this.submitBulkRequest(true);
                                }
                            }, active: true, disabled: _this.state.scannedPacks.length <= 0 }), placeholder: _this.props.applicationData.resources.ActionsWillAppear_Multiple, title: _this.props.applicationData.resources.SelectScanOption, resources: _this.props.applicationData.resources }); } }),
            React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Multiple/Queue', render: function () { return React.createElement(Pages_1.MultipleQueue, { applicationData: _this.props.applicationData }); } }),
            React.createElement(react_router_dom_1.Route, { path: '/Dashboard/Multiple/*', render: function () { return React.createElement(SafeRedirect_1.SafeRedirect, { to: "/Dashboard/Multiple", resources: _this.props.applicationData.resources }); } })));
    };
    return Multiple;
}(React.Component));
exports.Multiple = Multiple;
//# sourceMappingURL=Multiple.js.map